import { render } from "./continent-indicator.vue?vue&type=template&id=67caab7c&ts=true"
import script from "./continent-indicator.ts?vue&type=script&lang=ts&external"
export * from "./continent-indicator.ts?vue&type=script&lang=ts&external"

import "./continent-indicator.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__